import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import BSPagination from "../../Components/pagination";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

const RolePermissionsList = ({ rolePermissions, setRolePermissions }) => {
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 5,
    totalPages: 1,
  });

  const handleEditRolePermissions = (id) => {
    if (id) {
      localStorage.setItem("roleId", id);
      navigate(`/rolePermissions/edit`);
    }
  };

  // Slice for pagination
  const paginatedData = rolePermissions.slice(
    (pagination.currentPage - 1) * pagination.pageSize,
    pagination.currentPage * pagination.pageSize
  );

  // Initialize or update DataTable when paginatedData changes
  useEffect(() => {
    const rows = paginatedData.map((rp, idx) => [
      (currentPage - 1) * pageSize + idx + 1,
      rp.name?.toUpperCase() || "",
      rp.rolePermissions || 0,
      rp.status === 1 ? "Active" : "Inactive",
      "", // placeholder for actions column
    ]);

    const config = {
      data: rows,
      columns: [
        { title: "ID", className: "text-start" },
        { title: "Role" },
        { title: "Assigned Permissions" },
        { title: "Status" },
        { title: "Actions", orderable: false, searchable: false },
      ],
      destroy: true,
      paging: false,
      searching: false,
      info: false,
      responsive: true,
      createdRow: function (row, data, dataIndex) {
        // Render action button into last column
        const btn = $(
          `<button class="btn btn-sm btn-outline-primary"><i class="fa fa-edit" title="grant/revoke permissions"></i></button>`
        ).on("click", () =>
          handleEditRolePermissions(
            rolePermissions[(currentPage - 1) * pageSize + dataIndex].id
          )
        );
        $("td", row).eq(4).empty().append(btn);
        // Apply status color
        $("td", row)
          .eq(3)
          .addClass(data[3] === "Active" ? "text-success" : "text-danger");
      },
    };

    const $tbl = $(tableRef.current);
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $tbl.DataTable().clear().rows.add(rows).draw();
    } else {
      $tbl.DataTable(config);
    }

    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $tbl.DataTable().destroy();
      }
    };
  }, [paginatedData]);

  return (
    <div className="container py-4 bg-dark rounded mb-4 text-light">
      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table table-dark table-striped align-middle"
        />
      </div>
      <div className="d-flex justify-content-end mt-2">
        <BSPagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          onPageChange={(page) =>
            setPagination((p) => ({ ...p, currentPage: page }))
          }
          siblingCount={2}
          showFirstLast
        />
      </div>
    </div>
  );
};

export default RolePermissionsList;
